import React, { FunctionComponent, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../ui/Button/Button";
import { Input } from "../../../../ui/Input/Input";
import { InputGroup } from "../../../../ui/IputGroup/IputGroup";
import { CrossIcon } from "../../../../ui/icons/CrossIcon";
import { useCriteria } from "./useCriteria";

export const Criteria: FunctionComponent = () => {
  const { t } = useTranslation();
  const [criteria, setCriteria] = useCriteria();
  const inputRef = useRef<HTMLInputElement>(null);
  const reset = useCallback(() => {
    setCriteria("");
    const node = inputRef.current;
    if (node) {
      node.value = "";
    }
  }, [setCriteria]);
  return (
    <InputGroup className="w-full justify-stretch">
      <Input
        onChange={(event): void => {
          setCriteria(event.target.value);
        }}
        onKeyDown={(event): void => {
          if (event.key === "Escape") {
            reset();
            event.nativeEvent.stopImmediatePropagation();
          }
        }}
        aria-label="criteria"
        defaultValue={criteria}
        placeholder={t("searchResults.search")}
        ref={inputRef}
      />
      {criteria && (
        <Button
          aria-label="clearCriteria"
          className="aspect-square w-12 md:w-14 shrink-0 p-0 text-lg font-thin rounded-l-none"
          onClick={reset}
          type="button"
        >
          <CrossIcon />
        </Button>
      )}
    </InputGroup>
  );
};
